export default function constant(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-sankey/src/constant.js
// module id = 481
// module chunks = 0